//PasswordResetComponent.tsx

import React, { useState } from 'react';
import { Modal, Form, Input, Button, Alert } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import './AuthModal.css';

interface Props {
  isResetModalVisible: boolean;
  handleResetModalCancel: () => void;
  resetPassword: (email: string) => void;
}

const PasswordResetComponent: React.FC<Props> = ({ isResetModalVisible, handleResetModalCancel, resetPassword }) => {
  const [isResetEmailSent, setIsResetEmailSent] = useState(false);

  const onFormFinish = (email: string) => {
    resetPassword(email);
    setIsResetEmailSent(true);
  };

  const resetForm = () => {
    setIsResetEmailSent(false);
    handleResetModalCancel();
  };

  return (
    <Modal
      title="Reset Password"
      visible={isResetModalVisible}
      onCancel={resetForm}
      footer={null} // Remove default footer
      centered
      width={440}
      className="auth-modal"
    >
      {isResetEmailSent ? (
        <div className="auth-modal-body">
          <Alert
            type="success"
            showIcon
            message="Password reset link has been sent"
            description="Check your inbox for the reset link, then return to sign in."
            className="auth-modal-alert"
          />
          <Button type="primary" block onClick={resetForm}>Close</Button>
        </div>
      ) : (
        <Form className="auth-modal-body auth-modal-form" layout="vertical" onFinish={({ email }) => onFormFinish(email)}>
          <div className="auth-modal-block">
            <span className="auth-modal-kicker">Account recovery</span>
            <p>Enter your email and we will send a password reset link.</p>
          </div>

          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please input your email!', type: 'email' }]}
          >
            <Input prefix={<MailOutlined />} placeholder="Email" />
          </Form.Item>

          <Form.Item className="auth-modal-action-row">
            <Button type="primary" htmlType="submit" block>
              Send reset link
            </Button>
          </Form.Item>
        </Form>
      )}
    </Modal>
  );
};

export default PasswordResetComponent;
